import React, { PropsWithChildren } from 'react'
import { useDispatch } from 'react-redux'
import styled, { css } from 'styled-components'
import { NlpModelId } from '@feedyou-ai/feedbot-schema'

import { Button } from '../../design-system/Button'
import { updateBotProperties } from '../../../actions/bot'
import { useBotFlow, useNlpModels } from '../../../store/flow'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { ModalFooter, ModalContent, ModalFooterButton } from '../styles'

interface Props {
  modelId: NlpModelId
}

export const GeneralSection: React.FC<Props> = ({ modelId }) => {
  const flow = useBotFlow()
  const dispatch = useDispatch()
  const allModels = useNlpModels()

  const close = () => dispatch(modalsActions.closeModal())
  return (
    <>
      <ModalContent>
        <ActionsRow label="Actions">
          <Button
            size="medium"
            role="negative"
            emphasis="primary"
            label="Delete model"
            minMaxSizes={{ minWidth: 100, maxHeight: 36 }}
            onClick={async event => {
              event.preventDefault()
              const models = allModels.filter(model => model.id !== modelId)
              dispatch(updateBotProperties({ nlp: { ...flow?.nlp, models } }))
              close()
            }}
          />
        </ActionsRow>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButton label="Close" onClick={close} />
      </ModalFooter>
    </>
  )
}

const ActionsRow: React.FC<PropsWithChildren<{ label: string }>> = ({ label, children }) => {
  return (
    <div css={actionsRowCss.outerWrapper}>
      <span css={actionsRowCss.label}>{label}</span>
      <span css={actionsRowCss.content}>{children}</span>
    </div>
  )
}

const Wrapper = styled.div`
  margin-top: 20px;
`

const actionsRowCss = {
  content: css`
    width: calc(80% - 26px);
  `,
  label: css`
    font-weight: 700;
    margin-right: 10px;
    display: inline-block;
  `,
  outerWrapper: css`
    display: flex;
    flex-direction: row;
    min-height: 34px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  `
}
